import { UniButton } from '@/design-system/components/buttons';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { Icon } from '@/design-system/components/icons/Icon';
import { ModalHeader } from '@/design-system/components/modal';
import { UniNotes } from '@/design-system/components/notes/UniNote';
import { TextBody } from '@/design-system/components/typography';
import { SxProp, View, Image } from 'dripsy';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ReplaceCardProps {
  onClose: () => void;
  onStep: (step: string) => void;
}

export const ReplaceCardWebZeroScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose, onStep } = props;
  const { t } = useTranslation('account-management');
  const { topHeader, body, textMb, itemStyle, statement, noteContainer, title } = sxStyles;

  return (
    <View>
      <View sx={topHeader}>
        <ModalHeader title="Replace Card" closeModal={onClose} />
      </View>
      <View sx={body}>
        <TextBody sx={textMb} semiBold>
          Select a reason to replace the card.
        </TextBody>
        <View sx={{ gap: 10 }}>
          <TextBody sx={itemStyle} onPress={() => onStep('one')}>
            <TextBody semiBold>It’s lost/stolen</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
          <TextBody sx={itemStyle} onPress={() => onStep('one')}>
            <TextBody semiBold>It’s damaged</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
        </View>
        <View sx={statement}>
          <View>
            <Icon name="note" />
          </View>
          <TextBody>To prevent fraudulent transactions, your old card will be suspended once you request for a replacement.</TextBody>
        </View>
        <View sx={noteContainer}>
          <UniNotes
            title="Note"
            paragraphs={[
              '1. Your physical card will stop working immediately.\n2. Please update the card details with the online merchants, including the online and offline services you would like to use your UTGL card for.\n3. You will be charged a replacement fee of 50.00 HKD.'
            ]}
            sx={title}
          />
        </View>
        <View sx={{ flex: 1, display: 'grid', gap: '$3', mt: '$10' }}>
          <UniButton variant={ButtonVariant.outline1} sx={{ width: '100%', height: 44 }} label="Cancel" onPress={onClose} />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    height: 70,
    justifyContent: 'center'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  textMb: {
    marginBottom: 20
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 20,
    py: 30,
    cursor: 'pointer',
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowRadius: 10,
    borderRadius: 10
  },
  statement: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    backgroundColor: '#F9FAC7',
    borderRadius: 5,
    mt: '$5',
    px: 12,
    py: 12
  },
  noteContainer: {
    mt: '$5',
    color: '$textSecondary',
    gap: 4
  },
  title: {
    color: '$textSecondary',
    fontSize: 12
  }
};
